import script from "./OpdBillingTable.vue?vue&type=script&setup=true&lang=js"
export * from "./OpdBillingTable.vue?vue&type=script&setup=true&lang=js"

import "./OpdBillingTable.vue?vue&type=style&index=0&id=e149a236&scoped=true&lang=css"

import exportComponent from "/Users/amsrafid/Projects/www/miaccounts-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e149a236"]])

export default __exports__